export default __webpack_public_path__ + "static/media/previous-arrow.d3b6ad9f.svg";